let Landing = {
	lastCursorPosition: { x: innerWidth / 2, y: innerHeight / 2 },
	landingSize: Math.max(innerWidth, innerHeight),
	_init: () => {
		document.addEventListener('DOMContentLoaded', Landing._ready);
	},
	_ready: () => {
		// Media query for screen size change.
		const mq = window.matchMedia('(min-width: 1200px)');
		const cursor = document.querySelector('.landing.cursor');

		document.addEventListener('pointermove', Landing._onMouseMove);
		window.addEventListener('resize', Landing._resizeHandler);
		Landing._resizeHandler();

		// Check initial screen size and then add event listener.
		if (mq.matches && cursor instanceof HTMLElement) {
			Landing._navigateOut();
		}

		if (! (cursor instanceof HTMLElement)) {
			document.addEventListener('click', Landing._clickHandler);
			window.addEventListener('scroll', Landing._scrollHandler);
		}
	},
	_navigateOut: () => {
		window.removeEventListener('scroll', Landing._scrollHandler);
		window.removeEventListener('resize', Landing._resizeHandler);
		document.removeEventListener('click', Landing._clickHandler);

		const landing = document.querySelector('.landing');
		const wrapper = document.querySelector('.landing-wrapper');
		const background = document.querySelector('.landing-wrapper-background');
		const bgImage = document.querySelector('.landing-wrapper-background-image');

		landing.style.top = `${Landing.lastCursorPosition.y}px`;
		landing.style.left = `${Landing.lastCursorPosition.x}px`;
		background.style.width = '26px';
		background.style.height = '26px';
		
		landing.classList.add('cursor');
		background.classList.add('cursor');
		wrapper.classList.add('cursor-moved');
		bgImage.classList.add('cursor-moved');

		document.addEventListener(
			'pointermove',
			Landing._cursorMoveHandler
		);

		window.scrollTo({
			top: document.querySelector('header.wp-block-template-part').offsetTop,
			left: 0,
			behavior: 'instant'
		});
	},
	_cursorMoveHandler: (e) => {
		const { clientX, clientY } = e;
		const landing = document.querySelector('.landing');

		landing.style.top = `${clientY}px`;
		landing.style.left = `${clientX}px`;
	},
	_resizeHandler: (e) => {
		const gradient = document.querySelector('.landing-wrapper-background');
		gradient.style.width = `${Landing.landingSize}px`;
		gradient.style.height = `${Landing.landingSize}px`;
	},
	_scrollHandler: (e) => {
		Landing._navigateOut();
	},
	_clickHandler: (e) => {
		Landing._navigateOut();
	},
	_onMouseMove: (e) => {
		Landing.lastCursorPosition = { x: e.clientX, y: e.clientY }

		const cursor = document.querySelector('.landing.cursor');
		const landingBackground = document.querySelector('.landing-wrapper-background');

		const inLink = e.target.closest('a');
		const noCursorEl = e.target.closest('.no-cursor');

		if (cursor instanceof HTMLElement) { 
			if (noCursorEl) {
				cursor.style.visibility = 'hidden';
			} else {
				cursor.style.visibility = 'visible';
			}

			if (inLink) {
				landingBackground.classList.add('hover');
				landingBackground.style.width = `60px`;
				landingBackground.style.height = `60px`;
			} else {
				landingBackground.classList.remove('hover');
				landingBackground.style.width = `26px`;
				landingBackground.style.height = `26px`;
			}
		}
	}
};

Landing._init();